{
  "version": 1,
  "asset_id": "7a390952-4835-4f4a-ac6f-2942ec376c8f",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7a390952-4835-4f4a-ac6f-2942ec376c8f/bypass-revision-oversized-pouch-en-640.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7a390952-4835-4f4a-ac6f-2942ec376c8f/bypass-revision-oversized-pouch-en-640.webp",
  "original_filename": "bypass-revision-oversized-pouch-en-640.webp",
  "size": 34792,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:11:29Z"
}
